export default __webpack_public_path__ + "static/media/employmentGroup.bee0cb04.svg";